var io = require("socket.io-client");
var socket = io.connect(process.env.VUE_APP_SOCKET_URL, { reconnect: true });

export default socket;
